import { Component, Output, EventEmitter, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ToastService } from 'src/app/services/toast.service';
import { checkForValidationErrors } from 'src/app/utils/checkForValidationErrors';
import { ProjectsService } from '../service/projects.service';
import { FireworksService } from 'src/app/services/fireworks.service';
@Component({
  selector: 'apc-link-existing-project',
  templateUrl: './link-existing-project.component.html',
  styleUrls: ['./link-existing-project.component.scss'],
  providers: [ProjectsService],
})
export class LinkExistingProjectComponent {
  public form: UntypedFormGroup;
  @Output() backEvent = new EventEmitter<boolean>();
  @Output() operationSuccess = new EventEmitter<any>();

  @Input() budgetId: string;

  quickSearch = new Subject<any>();
  queryString: string = '';
  searchValue: string = '';
  result: any = '';
  isLoading: boolean = false;
  projectSelected: boolean = false;
  integrated: boolean | undefined = undefined;
  public modalRef: any;
  setDefaultBudget: boolean = false;

  constructor(
    private toastService: ToastService,
    public translate: TranslateService,
    private projectService: ProjectsService,
    public modalService: NgbModal,
    private fireworksService: FireworksService
  ) {
    this.quickSearch.pipe(debounceTime(1000), distinctUntilChanged()).subscribe((input) => {
      this.search(input.value);
    });
    this.initSingleForm();
  }

  initSingleForm() {
    this.form = new UntypedFormGroup({
      project: new UntypedFormControl(null, [Validators.required]),
      defaultBudget: new UntypedFormControl(false),
    });
  }

  async linkProject() {
    if (this.form.valid) {
      let projectIntegrated = this.form.value.project.integrated;
      this.projectService
        .linkProject(this.budgetId, this.form.value)
        .then((response) => {
          if(!projectIntegrated){
            this.showFireworks();
          }
          this.toastService.showSuccess('Operation Success!');
          this.operationSuccess.emit(response);
        })
        .catch((error) => {
          this.closeSearch();
          checkForValidationErrors(error, this.form);
        });
    } else {
      this.toastService.showError('Please check marked fields!');
      this.form.markAsPristine();
      this.form.markAllAsTouched();
    }
  }

  showFireworks(){
    this.fireworksService.playTemporaryFireworks()
  }

  cancel() {
    this.backEvent.emit();
  }
  async search(value: string) {
    this.searchValue = value;
    this.queryString = this.searchValue;
    this.isLoading = true;
    this.result = [];
    this.projectSelected = false;
    if (this.queryString.length > 0) {
      this.projectService.getProjectSearch(this.queryString).then(
        (res) => {
          this.result = res;
          this.isLoading = false;
        },
        (reason) => {
          this.isLoading = false;
        }
      );
    } else {
      this.result = [];
      this.isLoading = false;
    }
  }

  closeSearch() {
    this.result = [];
    this.searchValue = '';
    this.queryString = '';
    this.integrated = undefined;
    this.isLoading = false;
    this.setDefaultBudget = false;
    this.form.reset();
  }

  selectProject(project) {
    this.form.controls.project.patchValue(project);
    this.searchValue = this.constructDisplayName(project);
    this.integrated = project.integrated;
    this.projectSelected = true;
    if (this.integrated && project.numberOfBudgets > 0) {
      this.setDefaultBudget = true;
    } else {
      this.setDefaultBudget = false;
    }
  }

  constructDisplayName(project) {
    if (project.date) {
      return project.name + ' (' + project.key + ' - ' + project.date + ')';
    } else {
      return project.name + ' (' + project.key + ' - N/A)';
    }
  }
}
